/* unplugin-vue-components disabled */import { render } from "./huiyuan.vue?vue&type=template&id=aaab5a6c"
import script from "./huiyuan.vue?vue&type=script&lang=js"
export * from "./huiyuan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__